import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

export const requestMentorship = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/mentorship/request`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

export const bookSession = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/mentorship/book-session`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};